<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">我的委托</div>
        <div class="user_order_box">
            <div class="order_types">
                <div class="lefts">
                    <div class="types" :class="{ types_ac: types_ac == item.state }" v-for="(item, index) in type_list"
                        :key="index" @click="handle_type(item)">
                        {{ item.title }}
                    </div>
                </div>
                <div class="rights">
                    <el-input placeholder="输入关键字搜索" v-model="keyword">
                        <div slot="suffix" class="" @click="handle_seach">
                            <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                        </div>
                    </el-input>
                </div>
            </div>
            <div class="order_0" v-if="lists.length == 0">
                <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
                <div class="texts">暂无待处理订单</div>
            </div>
            <div class="lists">
                <div class="lists_tabs" v-if="lists.length > 0">
                    <div class="tables tab1">服务</div>
                    <div class="tables tab2">委托人</div>
                    <div class="tables tab3">创建时间</div>
                    <div class="tables tab4">服务费</div>
                    <div class="tables tab5">状态 </div>
                    <div class="tables tab6">操作 </div>
                </div>
                <div class="lists_items">
                    <div class="items" v-for="(item, index) in lists" :key="index">
                        <div class="item1" @click="handle_detial(item)">
                            {{ (item.pro||{}).title }}
                        </div>
                        <div class="item2">
                            {{ item.user.nickname }}
                        </div>
                        <div class="item3">
                            {{ item.created_at }}
                        </div>
                        <div class="item4">
                            {{ item.price }}
                        </div>
                        <div class="item5">
                            <!-- <div class="tage tage1" v-if="item.status==1">审核中</div>  -->
                            <div class="tage tage2" v-if="item.status == 30">服务中</div>
                            <div class="tage tage3" v-if="item.status == 40">已完成</div>
                            <!-- <div class="tage tage4" v-if="item.status==4">未通过</div>  -->
                        </div>
                        <div class="item6">
                            <div class="btns" @click="handle_detial(item)">查看详情</div>
                            <div class="borders" v-if="item.status == 30">丨</div>
                            <div class="btns" v-if="item.status == 30" @click="handle_xuigai(item)">修改律师服务费</div>
                            <div class="borders" v-if="item.status == 30">丨</div>
                            <div class="btns" v-if="item.status == 30" @click="hanlde_end(item)">服务完成</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pages.page" background :page-size="pages.limit" layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns" @click="handle_pages(last_page)">尾页</div>
            </div>
        </div>

        <el-dialog title="修改律师服务费" width="600px" :visible.sync="shows" :close-on-click-modal="false" :close-on-press-escape="false"
            :before-close="handleClose2">
            <div class="dialog_box2">
                <div class="form_flex">
                    <div class="titles">律师服务费：</div>
                    <div class="inputs">
                        <el-input v-model="price" placeholder="请输入律师服务费金额"></el-input>
                    </div>
                </div>
                <div class="btns_box">
                    <div class="btns1" @click="handle_price">确定</div>
                    <div class="btns2" @click="handleClose2">取消</div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { mapState } from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword: '',//
            types_ac: 30,//10待付款，20已付款待服务，30服务中，40已结项，50待评价
            type_list: [
                // {
                //     title:'审核中',
                //     state:1,
                // },
                {
                    title: '服务中',
                    state: 30,
                },
                {
                    title: '已完成',
                    state: 40,
                },
                {
                    title: '待评价',
                    state: 50,
                }

            ],
            lists: [],

            total: 100,
            pages: {
                page: 1,
                limit: 10,
            },
            last_page: 1,


            shows: false,
            item_ac:{},
            price:'',

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item) {
            this.types_ac = item.state
            this.pages.page = 1
            this.get_list()
        },
        handle_seach() {
            console.log('点击搜索')
            this.pages.page = 1
            this.get_list()
        },
        handleSizeChange(e) {
            console.log('条数', e)
            this.pages.page = 1
            this.pages.limit = 3
            this.get_list()
        },
        handleCurrentChange(e) {
            console.log('页数', e)
            this.pages.page = 3
            this.get_list()
        },
        handle_pages(i) {
            console.log('首页尾页', i)
            this.pages.page = i
            this.get_list()
        },
        handle_price(){
            this.loading = true
            this.$api("orderApply", {
                id:this.item_ac.id,
                price:this.price,
            }, "post").then((res) => {
                this.loading = false
                console.log('我的委托列表', res)
                if (res.code == 1) {
                    alertSucc('修改成功')
                    this.shows=false
                    this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleClose2(){
            this.price=''
            this.shows=false
        },
        get_list() {
            this.loading = true
            this.$api("lawyerOrders", {
                keywords: this.keyword,
                status: this.types_ac,
                ...this.pages,
            }, "post").then((res) => {
                this.loading = false
                console.log('我的委托列表', res)
                if (res.code == 1) {
                    this.lists = res.data.data
                    this.total = res.data.total
                    this.last_page = res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_detial(item) {
            this.$router.push({
                path: '/user_wtfw/user_wtfw_detial',
                query: {
                    id: item.id
                }
            })
        },
        handle_xuigai(item) {
            this.item_ac=item
            this.shows=true
        },
        hanlde_end(item) {
            this.$confirm('确定完成服务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                this.$api("lawyerFinishOrder", {
                    id: item.id
                }, "post").then((res) => {
                    this.loading = false
                    console.log('我的委托列表', res)
                    if (res.code == 1) {
                        this.get_list()
                    } else {
                        alertErr(res.msg)
                    }
                });
            }).catch(() => {

            });
        },




    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .user_order_box {
        padding: 24px 32px;
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;

        .order_types {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .lefts {
                display: flex;
                align-items: center;

                .types {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;

                    &:hover {
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }

                .types_ac {
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }

            .rights {
                /deep/.el-input {
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;

                    // border: 1px solid #B8C4D1;
                    .el-input__inner {
                        width: 282px;
                        height: 32px;
                    }

                    .el-input__suffix {
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;

                        img {
                            width: 18px;
                        }
                    }
                }
            }
        }

        .order_0 {
            text-align: center;
            padding-top: 65px;

            img {
                width: 190px;
            }

            .texts {
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }

        .lists {
            padding-top: 23px;

            .lists_tabs {
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;

                .tables {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;

                }

                .tab1 {
                    width: 200px;
                    flex-shrink: 0;
                }

                .tab2 {
                    width: 120px;
                    flex-shrink: 0;
                }

                .tab3 {
                    width: 220px;
                    flex-shrink: 0;
                }

                .tab4 {
                    width: 100px;
                    flex-shrink: 0;
                }

                .tab5 {
                    width: 100px;
                    flex-shrink: 0;
                }

                .tab6 {
                    width: 300px;
                    flex-shrink: 0;
                }
            }

            .lists_items {
                .items {
                    height: 100px;
                    border-left: 1px solid #E5E5E5;
                    border-right: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    padding: 0 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .item1 {
                        width: 200px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;

                    }

                    .item2 {
                        width: 120px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;


                    }

                    .item3 {
                        width: 220px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }

                    .item4 {
                        width: 100px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;



                    }

                    .item5 {
                        width: 100px;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;

                        .tage {
                            width: 88px;
                            height: 28px;
                            border-radius: 2px 2px 2px 2px;
                            flex-shrink: 0;
                            text-align: center;
                            line-height: 28px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;

                        }

                        .tage1 {
                            border: 1px solid #FF4D4F;
                            background: #FFF1F0;
                            color: #FF5759;
                        }

                        .tage2 {
                            border: 1px solid #1890FF;
                            background: #E6F7FF;
                            color: #1890FF;
                        }

                        .tage3 {
                            border: 1px solid #52C428;
                            background: #F6FFED;
                            color: #3BB363;
                        }

                        .tage4 {
                            border: 1px solid #FFC44D;
                            background: #FFFBF0;
                            color: #FFAB57;
                        }
                    }

                    .item6 {
                        width: 300px;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        display: flex;
                        align-items: center;

                        // justify-content: flex-end;
                        .btns {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #377CFD;
                            cursor: pointer;
                        }

                        .borders {
                            color: #D7D7D7;
                            font-size: 16px;
                            // background-color: #D7D7D7;
                            margin: 0 5px;
                        }
                    }
                }
            }

        }

        .pages_box {
            width: 100%;
            height: 100px;
            // background-color: red;
            display: flex;
            align-items: center;
            justify-content: end;

            /deep/.el-pagination {
                .btn-prev {
                    background-color: #FFFFFF;
                    border: 1px solid #EEEEEE;

                }

                .el-pager {
                    .number {
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;

                    }

                    .active {
                        background-color: #377CFD;
                    }

                    .el-icon {
                        background-color: #FFFFFF;
                    }
                }

                .btn-next {
                    background-color: #FFFFFF;
                    border: 1px solid #EEEEEE;

                }
            }

            .btns {
                width: 40px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #EEEEEE;
                font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                font-weight: normal;
                font-size: 14px;
                color: #7A7A7A;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
    }

    .dialog_box2 {
        .form_flex {
            display: flex;
            align-items: center;
            justify-content: center;

            .inputs {
                width: 400px;
            }
        }

        .btns_box {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 40px;

            .btns1 {
                width: 104px;
                height: 40px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                cursor: pointer;
                text-align: center;
                line-height: 40px;
            }

            .btns2 {
                width: 104px;
                height: 40px;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                cursor: pointer;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                margin-left: 20px;
            }

        }
    }
}
</style>